import './App.css';
import { CssBaseline, ThemeProvider, IconButton } from '@mui/material';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useMemo, useEffect } from 'react';
import { getTheme } from './theme/theme';
import AppRoutes from './routes/AppRoutes';
import { useVersionCheck } from './hooks/useVersionCheck';
import { usePathname } from './routes/hooks/use-pathname';

function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const App = () => {
  useScrollToTop();
  useVersionCheck();

  const [mode, setMode] = useState<'light' | 'dark'>('light');
  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={null} // 👈 no auto-hide
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        action={(snackbarId) => (
          <IconButton
            size="small"
            onClick={() => closeSnackbar(snackbarId)}
            color="inherit"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      >
        <AppRoutes mode={mode} setMode={setMode} />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
